var map = {
	"./cat-stare-1.gif": [
		4900,
		900
	],
	"./cat-stare-2.gif": [
		9163,
		163
	],
	"./cat-stare-3.gif": [
		8835,
		835
	],
	"./cat-stare-4.gif": [
		9510,
		510
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3644;
module.exports = webpackAsyncContext;